import React from 'react';
import styled, { css } from 'styled-components';

import Fleet from '@pedidosya/web-fenix/icons/Fleet';
import Tag from '@pedidosya/web-fenix/system/Tag';

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.shoplist.shopCard.delivery.marginTop};
  span {
    font-size: 12px;
    align-self: center;
    align-content: center;
    line-height: 18px;
    padding: 2px 0;
    color: ${({ theme }) => theme.shoplist.shopCard.delivery.color};
  }
  div {
    align-self: center;
    color: ${props => props.theme.colors.textSecondary};
    padding-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;

export const Separator = styled.span`
  margin-right: ${({ width }) => `${width ?? 5}px`};
  margin-left: ${({ width }) => `${width ?? 5}px`};
`;

export const FleetUtilisationIcon = styled(Fleet)`
  margin-left: ${({ theme }) => theme.spacing(2)};
  fill: ${({ theme }) => theme.colors.textSecondary};
`;

export const StyledPrice = styled.span`
  ${({ theme, underlined }) =>
    !!underlined &&
    css`
      &&& {
        text-decoration: line-through;
        color: ${theme.colors.night_blue_3};
      }
    `};
  ${({ theme, bold }) =>
    !!bold &&
    css`
      &&& {
        ${theme.fontFamily.secondaryFont.xSmallBold}
        color: ${theme.shoplist.shopCard.peyaPlus.freeShippingTextColor};
      }
    `};
`;

const StyledPlusTag = styled.div`
  display: inline-flex;
  align-items: center;

  svg {
    & > path {
      fill: ${({ theme }) => theme.colors.white};
      &:first-child {
        fill: ${({ theme }) => theme.colors.red};
      }
    }
  }

  & > div {
    margin-right: ${({ theme }) => theme.spacing(2)};
    color: ${({ theme }) => theme.commons.tags.plus.color};
    background: ${({ theme }) => theme.commons.tags.plus.background};
    padding: ${({ theme }) => theme.spacing(1, 0, 0, 2)};
  }
`;

export const StyledPeyaPlus = () => (
  <StyledPlusTag>
    <Tag category="peya-plus" hasPlus />
  </StyledPlusTag>
);
